module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/logo_login_batchat@2x.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f60a9834"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/components/Icon.vue
// module id = 751
// module chunks = 1